import { Button } from 'flowbite-react';
import { Link } from 'react-router-dom';

export default function EmailVerifiedPage() {
  return (
    <div className="flex flex-col flex-1 px-12 pt-7 pb-9">
      <h3 className="text-2xl font-bold text-slate-700 text-center">Email Verified</h3>

      <div className="h-4" />

      <p className="text-sm text-center text-slate-700">Your email has been verified. You can now log in.</p>

      <div className="hidden flex-1 sm:flex" />

      <Link to="/">
        <Button size="lg" color="dark" pill className="font-semibold w-full">
          Go to Login
        </Button>
      </Link>
    </div>
  );
}
